export default __webpack_public_path__ + "static/media/buyer_data.3a4ce9a2.png";